
import React from 'react';
import CalendarViewRenderer from './calendar/CalendarViewRenderer';

interface CalendarViewSwitcherProps {
  viewMode: any;
  currentDate: Date;
  filteredSchedules: any;
  dateRange: any;
  isCustomView: boolean;
  isAdmin: boolean;
  guards: any;
  selectedGuardId: string;
  guardSchedules: any;
  allGuardsSchedules: any;
  isLoadingGuardSchedules: boolean;
  user: any;
  permissions: any;
  handleDayClick: (date: Date) => void;
  handleEventClick: (event: any, e: React.MouseEvent, isMultiSelectMode?: boolean) => void;
  onDuplicateEvent: (event: any) => void;
  onDeleteEvent: (event: any) => void;
  handleGuardSelect: (guardId: string) => void;
  onMarkForSwap?: (event: any) => void;
  onSwapWithMarked?: (event: any) => void;
  onCancelSwap?: () => void;
  markedShiftId?: string | null;
  onDragEnd?: (result: any) => void;
  viewType?: 'standard' | 'per-job';
  calendarZoom?: number;
}

const CalendarViewSwitcher: React.FC<CalendarViewSwitcherProps> = (props) => {
  const { calendarZoom = 0.9, ...otherProps } = props;
  
  return (
    <div className="calendar-view-container w-full">
      <CalendarViewRenderer {...otherProps} calendarZoom={calendarZoom} />
    </div>
  );
};

export default CalendarViewSwitcher;
